import { Base } from '../../abstract/base.model';
import { ChemicalSource } from './chemical-source.model';
import { isRecord } from '../utils/is-record';
import { nullableNumber, nullableString } from '../utils/wire-value-utils';

/**
 * One chemical of a chemical template (hub `data-models/chemical-template-item.ts`). Links to a book chemical
 * (`chemicalId`) or an organization chemical (`customChemicalId`). `source` is added by the hub when it reads a
 * template (null when the item links to neither).
 */
export class ChemicalTemplateItem extends Base {
  templateId?: string | null;
  chemicalId?: string | null;
  customChemicalId?: string | null;
  name?: string | null;
  epaNumber?: string | null;
  source?: ChemicalSource | null;
  rate?: string | null;
  rateValue?: number | null;
  rateUnit?: string | null;
  ratePerUnit?: string | null;
  purpose?: string | null;
  sortOrder?: number | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.templateId = nullableString(source['templateId']);
    this.chemicalId = nullableString(source['chemicalId']);
    this.customChemicalId = nullableString(source['customChemicalId']);
    this.name = nullableString(source['name']);
    this.epaNumber = nullableString(source['epaNumber']);
    this.source = nullableString(source['source']) as ChemicalSource | null | undefined;
    this.rate = nullableString(source['rate']);
    this.rateValue = nullableNumber(source['rateValue']);
    this.rateUnit = nullableString(source['rateUnit']);
    this.ratePerUnit = nullableString(source['ratePerUnit']);
    this.purpose = nullableString(source['purpose']);
    this.sortOrder = nullableNumber(source['sortOrder']);
  }
}
